import { of } from "rxjs";
import { apiService } from "../../ApiService";

export const logout = () => {
  if (!apiService.familyToken || !apiService.userToken) {
    apiService.userToken = undefined;
    apiService.familyToken = undefined;
    return of({});
  }
  const token = apiService.userToken?.accessToken;
  apiService.userToken = undefined;
  apiService.familyToken = undefined;
  return apiService.request<unknown>({
    method: "post",
    path: `v1/auth/revoke`,
    body: { accessToken: token },
  });
};
